import { useSelector } from 'react-redux';
import { RetailRootState } from '../store/reducers';

export function useMe() {
  const user = useSelector(
    (state: RetailRootState) => state.firestore.ordered.me?.[0] || null
  );
  return user;
}
